import { LotionPlusOutlineIcon } from './LotionPlusOutlineIcon';

/**
 * author: Google
 * id 85DF6891-1BE0-4D66-8728-553846F98B1F
 * name lotion-plus-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lotion-plus-outline.svg
 * tags
 * - Medical / Hospital 
 */
export const HandSanitizerOutlineIcon = LotionPlusOutlineIcon;
export default HandSanitizerOutlineIcon